import Velocity from '../../node_modules/velocity-animate/velocity';
import { tns } from '../../node_modules/tiny-slider/src/tiny-slider';
import makeTurnable from './lib/flip-tiles';

window.Velocity = Velocity;

const $ = jQuery;

var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
if (isIE11) {
  $('body').addClass('-is-ie-11');
}

$(document).ready(() => {
  makeTurnable('.flip-tile');


  if ($('.image-slider__container').length > 0) {

    tns({
      container: '.image-slider__container',
      mode: 'carousel',
      items: 1,
      autoplay: true,
      autoplayButtonOutput: false,
      edgePadding: 0,
      gutter: 30,
      swipeAngle: false,
      slideBy: 1,
      nav: true,
      navPosition: 'bottom',
      controls: false,
      responsive: {
        576: {
          items: 2,
        },
        768: {
          items: 3,
        },
        992: {
          items: 4
        },
        1200: {
          items: 4
        }
      }
    });
  }

  if ($('.page-header__container').length > 0) {
    tns({
      container: '.page-header__container',
      mode: 'gallery',
      items: 1,
      autoplay: true,
      autoplayButtonOutput: false,
      edgePadding: 0,
      gutter: 0,
      swipeAngle: false,
      slideBy: 1,
      nav: false,
      navPosition: 'bottom',
      controls: false,
      speed: 1500,
    })
  }
});